module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/sightseeing@2x_5259a8.jpg";